import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=bff3262c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff3262c')) {
      api.createRecord('bff3262c', component.options)
    } else {
      api.reload('bff3262c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=bff3262c&", function () {
      api.rerender('bff3262c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/offershelp.vue"
export default component.exports